import React from "react";
import "./MyServices.css";
import {SectionHeading2} from "../";
import HorizontalAccordion from "./HorizontalAccordion/HorizontalAccordion";
import {OutlinedLogoWhite} from "../../assets/images";
import {serviceData} from "../../constants/Services";

const MyServices = () => {
  return (
    <section className="section my-services-section">
      <div className="container my-services-container">
        <SectionHeading2
          title1="How I Can"
          title2="Help You"
          description="Comprehensive digital services to boost your online presence and
            achieve impactful results."
          image={OutlinedLogoWhite}
        />
        <HorizontalAccordion items={serviceData} />
      </div>
    </section>
  );
};

export default MyServices;
